import React from 'react';
import { Space, Breadcrumb } from 'antd';
import { CardLayout, B2BTable } from 'components/molecules';
import SearchBox from './SearchBox'
import { useProject } from 'hooks';


export interface  ProjectConfirmProps {}

const  ProjectConfirm = ({}:  ProjectConfirmProps): React.ReactElement => {
  /* ======================================================
   * hooks
   * ====================================================== */

  const { projectList, searchResult, refetch } = useProject();  
 

  /* ======================================================
   * variables
   * ====================================================== */

  
  /* ======================================================
   * events
   * ====================================================== */    
  
  /* ======================================================
   * hooks
   * ====================================================== */
  

  /* ======================================================
   * render items
   * ====================================================== */
  return (
    <CardLayout title={(
      <Breadcrumb>
        <Breadcrumb.Item>Home</Breadcrumb.Item>
        <Breadcrumb.Item>B2B</Breadcrumb.Item>
        <Breadcrumb.Item>확정</Breadcrumb.Item>
    </Breadcrumb>      
    )}>
        <Space direction="vertical" style={{ width: '100%' }}>
          <SearchBox />
          <B2BTable 
            pType='confirm'
            projectList={projectList} 
            searchResult={searchResult} 
            hiddenColumns={['project_step', 'history']}
            refetch={refetch}/>
        </Space>                
    </CardLayout>
  )
};

export default  ProjectConfirm;    